import { useQuery } from "@tanstack/react-query";
import { getApiCcofPracticeIdPatientsPatientId } from "@/lib/api-client/endpoints/ccof-patient/ccof-patient";
import { useTenantRouteContext } from "@/components/app-shell/TenantRouteContext";
import { CcofPatientDetails } from "lib/api-types/schemas";
import { useEffect } from "react";
import { Patient } from "../types";
import patientToPatientDetailsAdapter from "../utils/patientToPatientDetailsAdapter";

export const patientDetailsQueryKey = (practiceId: string, patientId: string) =>
  ["patients", "details", practiceId, patientId] as const;

export function usePatientDetails(
  patientId: string | null,
  onError?: VoidFunction,
  placeholderData?: Patient,
) {
  const { tenantId } = useTenantRouteContext();

  const query = useQuery<CcofPatientDetails>({
    queryKey: patientDetailsQueryKey(tenantId, patientId ?? ""),
    queryFn: () =>
      getApiCcofPracticeIdPatientsPatientId(tenantId, patientId!).then(
        (res) => res.data,
      ),
    enabled: patientId !== null,
    retry: false,
    // Placeholder (not initialData) so partial list data is rendered immediately
    // but never written to the cache as the authoritative patient details.
    placeholderData:
      placeholderData && placeholderData.patientId === patientId
        ? patientToPatientDetailsAdapter(placeholderData)
        : undefined,
  });

  useEffect(() => {
    if (query.isError) onError?.();
  }, [query.isError, onError]);

  return query;
}
